<template>
  <div>
    <mapbox
      :access-token="accessToken"
      :map-options="mapOptions"
      :geolocate-control="geolocate"
      :scale-control="scale"
      :fullscreen-control="fullscreen"
      @map-load="mapLoaded"
    ></mapbox>
    <div class="image"></div>
  </div>
</template>

<script>
import Mapbox from 'mapbox-gl-vue';

export default {
  name: 'TheMap',
  components: {
    Mapbox,
  },
  data() {
    return {
      accessToken:
        'pk.eyJ1IjoidG9tYXNyZXF1ZW5hYiIsImEiOiJjanhjZHk4MHAwMmczM3R0Z2E2ZTBmNjZnIn0.obx1kEioXW8FizkdZyciUA',
      mapOptions: {
        style: 'mapbox://styles/mapbox/light-v9',
        center: [-79.517717, 8.986798], // -79.517717, 8.986798 | -79.521436, 8.986509
        zoom: 15,
      },
      scale: {
        show: false,
      },
      geolocate: {
        show: true,
        position: 'top-left',
      },
      fullscreen: {
        show: true,
        position: 'bottom-left',
      },
      windowWidth: 1200,
    };
  },
  methods: {
    mapLoaded(map) {
      map.addLayer({
        id: 'location',
        type: 'symbol',
        source: {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: [
              {
                type: 'Feature',
                geometry: {
                  type: 'Point',
                  coordinates: [-79.521436, 8.986509],
                },
                properties: {
                  title: 'BGS Estudio Jurídico',
                },
              },
            ],
          },
        },
        layout: {
          'icon-image': 'marker-15',
          'icon-size': 1.5,
          'text-field': '{title}',
          'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
          'text-offset': [0, 1],
          'text-anchor': 'top',
        },
      });
    },
    updateMapCenter(windowWidth) {
      if (windowWidth <= 600) {
        this.mapOptions.center[0] = -79.521436;
        this.mapOptions.center[1] = 8.986509;
      } else {
        this.mapOptions.center[0] = -79.517717;
        this.mapOptions.center[1] = 8.986798;
      }
    },
    // addMarker(map) {
    //   var geojson = {
    //     type: 'FeatureCollection',
    //     features: [
    //       {
    //         type: 'Feature',
    //         geometry: {
    //           type: 'Point',
    //           coordinates: [-79.521436, 8.986509]
    //         },
    //         properties: {
    //           title: 'Mapbox',
    //           description: 'Washington, D.C.'
    //         }
    //       }
    //     ]
    //   };

    //   geojson.features.forEach(function(marker) {
    //     // create a HTML element for each feature
    //     var el = document.createElement('div');
    //     el.className = 'marker';

    //     // make a marker for each feature and add to the map
    //     new mapboxgl.Marker(el)
    //       .setLngLat(marker.geometry.coordinates)
    //       .addTo(map);
    //   });
    // },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('load', () => {
        this.windowWidth = window.innerWidth;
        this.updateMapCenter(this.windowWidth);
        console.log(`Width: ${this.windowWidth}`);
        console.log(`Centro del Mapa: ${this.mapOptions.center}`);
      });
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth;
        this.updateMapCenter(this.windowWidth);
        console.log(`Width: ${this.windowWidth}`);
        console.log(`Centro del Mapa: ${this.mapOptions.center}`);
      });
    });
  },
};
</script>

<style lang="scss" scoped>
#map {
  width: 100%;
  height: 500px;

  /* div.marker {
    background-image: url("../assets/images/mapbox-icon.png");
    background-size: cover;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
  } */
}

@media screen and (max-width: 900px) {
}

@media screen and (max-width: 600px) {
  #map {
    height: 350px;
  }
}
</style>
